import api from '@/api/file'
import { mergeUserContext } from '@/store/helpers'

const state = {
  files: [],
  allDashboardFileResponse: null,
  fileRecordCount: 0
}

const getters = {
  getFiles: state => state.files,
  getFileResponse: state => state.allDashboardFileResponse,
  getFileRecordCount: state => state.fileRecordCount
}

const actions = {
  // How many do we have?
  async getFileRecordCount ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)

    var response = await api.getFiles(payload)
    response = response.body

    commit('setFileRecordCount', response.length)
    return response.data
  },
  async getFiles ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)

    var response = await api.getFiles(payload)
    commit('setFiles', response.body)
    commit('setAllDashboardFileResponse', response.body)
    return response.body
  }
}

const mutations = {
  setFiles (state, records) {
    state.files = records
  },
  setAllDashboardFileResponse (state, records) {
    state.allDashboardFileResponse = _.isArray(records)
  },
  setFileRecordCount (state, count) {
    state.fileRecordCount = count
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/file.js